import { judgeDeviceType } from '@/utils/device'
import Konva from 'konva'
/**
 * 特效
 */
export class VFX {
  stage: Konva.Stage
  layer: Konva.Layer
  videoCanvasRef: any
  anim: Konva.Animation
  video: HTMLVideoElement
  image: Konva.Image
  isPlaying = false
  lastSpecialEffect: any[] = []
  specialEffectList: any[] = []
  videoList: any[] = []
  controlPlaying = false
  constructor(videoCanvasRef, specialEffectList) {
    this.videoCanvasRef = videoCanvasRef
    this.specialEffectList = specialEffectList
    this.initCavans()
  }
  /**
   * 初始化canvas
   */
  initCavans() {
    if (judgeDeviceType.isIOS) return
    this.stage = new Konva.Stage({
			container: 'video_vfx',
			width: this.videoCanvasRef.clientWidth,
			height: this.videoCanvasRef.clientHeight,
		})
    this.layer = new Konva.Layer()
		this.stage.add(this.layer)
    this.anim = new Konva.Animation(function () {
			// do nothing, animation just need to update the layer
		}, this.layer)
    this.initVideoList()

  }
  initVideoList() {
    this.specialEffectList.forEach(item => {
      const video = document.createElement('video')
      video.src = item.url
      video.volume = 0.2
      const image = new Konva.Image({
        image: video,
        x: 0,
        y: 0,
        width: this.stage.width(),
        height: this.stage.height()
      })
      this.layer.add(image)
      this.videoList.push({video, image})
    })
  }
  /**
   * 渲染vfx
   * @param 
   * @returns 
   */
  drawVFXByPlay(curTime, type?) {
    if (!curTime && !this.controlPlaying) {
      if (type) {
        this.updateVideoByTime(curTime)
      }
      // this.clearLayer()
      return
    }
    const specialEffects = this.getCurrentVFXByTime(curTime)
    if (!specialEffects.length || !specialEffects) {
      this.clearLayer()
      return
    }
    if (JSON.stringify(this.lastSpecialEffect) === JSON.stringify(specialEffects)) {
      if (type) {
        this.updateVideoByTime(curTime)
      }
      return
    }
    this.clearLayer()
    this.lastSpecialEffect = specialEffects
    specialEffects.forEach((item, index) => {
        if (this.videoList.length) {
          const video = this.videoList[index].video
          const image = this.videoList[index].image
          video.src = item.url
          video.volume = 0.2
          image.image(video)
          image.draw()
        } else {
          const video = document.createElement('video')
          video.src = item.url
          video.volume = 0.2
          const image = new Konva.Image({
            image: video,
            x: 0,
            y: 0,
            width: this.stage.width(),
            height: this.stage.height()
          })
          this.layer.add(image)
          this.videoList.push({video, image})
        }
       
    })
    if (type) {
      this.updateVideoByTime(curTime)
      return
    }
    // if (!this.isPlaying) {
    //   this.play()
    // } else {
    //   this.stop()
    //   this.play()
    // }
    this.play()
   

  }
  clearLayer() {
    this.lastSpecialEffect = []
    this.videoList.forEach(item => {
      item.video.src = ''
      item.image.clearCache()
    })
    this.layer.clearBeforeDraw()
  }
  updateVideoByTime(time) {
    const specialEffects = this.getCurrentVFXByTime(time)
    if (!specialEffects.length || !specialEffects) {
      this.clearLayer()
      return
    }
    specialEffects.forEach((item, index) => {
      const diffTime = time - item.startTime
      const video = this.videoList[index].video
      const image = this.videoList[index].image
      video.src = item.url
      video.volume = 0
      video.currentTime = diffTime
      image.image(video)
      image.draw()
    })
    // this.play()
    // setTimeout(() => {
    //   this.stop()
    // })
  }
  // 根据时间获取要渲染的特效
	getCurrentVFXByTime(time) {
		const specialEffects = this.specialEffectList.filter(item => item.startTime <= time && item.endTime >= time)
		return specialEffects
	}
  play() {
    console.log('video-play---')
    this.controlPlaying = true
    if (!this.videoList.length) return
    
    this.videoList.forEach((item) => {
      if (item.video.src && item.video.src.indexOf('.webm') !== -1) {
        item.video.play()
        item.video.loop = true
      }
      
    })
    this.anim.start()
    this.isPlaying = true
  }
  stop() {
    console.log('video-stop---')
    this.controlPlaying = false
    if (!this.videoList.length) return
  
    this.videoList.forEach((item) => {
      item.video.pause()
    })
    // this.anim.stop()
    this.isPlaying = false
  }
}